import React from 'react';
import { API_BASE_URL } from "../environment";
import { API } from "../common/Constants";
import LoadingSpinner from '../components/LoadingSpinner';
import '../styles/TermsAndConditions.css';
import CancellationAndRefundJson from '../data/CancellationAndRefund.json';

const CancellationAndRefund = () => {
  const [termsAndCondtions, setTermsAndConditions] = React.useState();
  const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
      const fetchTerms = async () => {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}${API.TERMS_AND_CONDITIONS}`);
        const data = await response.json();
        if (response.ok) {
          setTermsAndConditions(JSON.parse(data?.content));
        } else {
          console.error("Failed to fetch terms and conditions:", data);
        }
        setLoading(false);
      };
  
     //fetchTerms();
     setTermsAndConditions(CancellationAndRefundJson);
    }, []);

  const renderContent = (content) => {
    if (!content) return null;

    return content.map((item, index) => {
      switch (item.type) {
        case 'h1':
          return <h1 key={index} dangerouslySetInnerHTML={{ __html: item.text || '' }} />;
        case 'h2':
          return (
            <div key={index} className="terms-section">
              <h3 dangerouslySetInnerHTML={{ __html: item.text || '' }} />
              {item.content && renderContent(item.content)}
            </div>
          );
        case 'paragraph':
          return (
            <div key={index} className="terms-paragraph-wrapper">
              <p dangerouslySetInnerHTML={{ __html: item.text || '' }} />
              {item.content && renderContent(item.content)}
            </div>
          );
        case 'ul':
          return (
            <ul key={index} className="terms-list">
              {item.items && item.items.map((listItem, listIndex) => (
                <li key={listIndex} className="terms-list-item">
                  <span dangerouslySetInnerHTML={{ __html: listItem.text || '' }} />
                  {listItem.content && renderContent(listItem.content)}
                </li>
              ))}
            </ul>
          );
        default:
          return null;
      }
    });
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="terms-container">
      <h1 className="terms-main-heading" dangerouslySetInnerHTML={{ __html: 'Cancellation and Refund Policy' }} />
      {renderContent(termsAndCondtions?.content)}
    </div>
  );
};

export default CancellationAndRefund;